import { Drawer } from "@JohnLewisPartnership/jl-design-system/dist/components/drawer/Drawer";
import { Energy } from "@~/types/prodcatBaseTypes";
import { InformationSheet } from "./InformationSheet";
import { EnergyImage } from "./EnergyImage";
import styles from "../EnergyRating.module.scss";

type Props = {
  handleClose: () => void;
  isOpen: boolean;
  energy: Energy;
  altText?: string;
};

export function EnergyDrawer({ handleClose, isOpen, energy, altText }: Props) {
  return (
    <>
      <Drawer
        data-testid="energy-rating-drawer"
        className={styles.energyDrawer}
        heading={`Energy Rating: ${energy.rating.value}`}
        isOpen={isOpen}
        onClose={handleClose}
        position="right"
      >
        <InformationSheet energy={energy} />
        <EnergyImage energy={energy} altText={altText} />
      </Drawer>
    </>
  );
}
